export const GENERATE_SDK_REQUEST = 'GENERATE_SDK_REQUEST';
export const GENERATE_SDK_SUCCESS = 'GENERATE_SDK_SUCCESS';
export const GENERATE_SDK_FAILURE = 'GENERATE_SDK_FAILURE';
